import Reveal from 'components/ui/Reveal';
import SectionHeading from 'components/ui/SectionHeading';
import sahilImage from '../../images/Founders/Sahilbhai.jpg';
import hemangImage from '../../images/Founders/Hemangbhai.jpg';

export default function FoundersSection() {
  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-singaraa-cream">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-20 max-w-4xl text-center">
        <Reveal>
          <SectionHeading
            eyebrow="THE MINDS BEHIND SINGARAA"
            title="Built With a Simple Belief"
            subtitle="Two minds, one shared passion for elevating Indian snacking tradition into a modern, wholesome delight"
            className="mb-8 sm:mb-12 md:mb-14"
          />
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-8 sm:mt-12 flex flex-col sm:flex-row items-center sm:items-start justify-center gap-8 sm:gap-12 md:gap-16">
            <div className="w-64 sm:w-72 md:w-80 flex flex-col items-center text-center">
              <div className="w-28 h-28 sm:w-36 sm:h-36 md:w-40 md:h-40 rounded-full bg-singaraa-beige flex items-center justify-center overflow-hidden border-4 border-singaraa-ivory shadow-lg relative mb-3 sm:mb-4">
                <img src={sahilImage} alt="Sahil - Founder & CEO" className="w-full h-full object-cover" />
              </div>
              <h3 className="text-lg sm:text-xl font-heading text-singaraa-dark font-semibold tracking-wide">Sahil </h3>
              <p className="text-xs sm:text-sm font-body text-singaraa-brown tracking-wider uppercase font-semibold mt-0.5 sm:mt-1 mb-3">
                Founder &amp; CEO
              </p>
              <p className="text-sm font-body text-singaraa-dark/70 leading-relaxed px-2">
                Leading Company Vision, Brand Building, Business Strategy &amp; Market Expansion.
              </p>
            </div>

            <div className="hidden sm:block w-px h-52 sm:h-60 bg-singaraa-beige self-center" />

            <div className="w-64 sm:w-72 md:w-80 flex flex-col items-center text-center">
              <div className="w-28 h-28 sm:w-36 sm:h-36 md:w-40 md:h-40 rounded-full bg-singaraa-beige flex items-center justify-center overflow-hidden border-4 border-singaraa-ivory shadow-lg relative mb-3 sm:mb-4">
                <img src={hemangImage} alt="Hemang - Co-Founder & Managing Director" className="w-full h-full object-cover" />
              </div>
              <h3 className="text-lg sm:text-xl font-heading text-singaraa-dark font-semibold tracking-wide">Hemang</h3>
              <p className="text-xs sm:text-sm font-body text-singaraa-brown tracking-wider uppercase font-semibold mt-0.5 sm:mt-1 leading-snug mb-3">
                Co-Founder &amp; Managing Director
              </p>
              <p className="text-sm font-body text-singaraa-dark/70 leading-relaxed px-2">
                Leading Operations, Financial Planning, Execution &amp; Business Administration.
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.4}>
          <div className="mt-10 sm:mt-16 bg-white p-5 sm:p-8 md:p-12 rounded-xl sm:rounded-2xl shadow-[0_10px_40px_-15px_rgba(0,0,0,0.05)] border border-singaraa-beige/50">
            <div className="text-singaraa-caramel text-4xl sm:text-5xl font-serif leading-none mb-3 sm:mb-4">"</div>
            <p className="text-xl sm:text-2xl md:text-3xl font-heading text-singaraa-dark mb-4 sm:mb-6 leading-tight">
              Transforming simplicity into the next era of richness.
            </p>
            <p className="text-singaraa-brown font-body text-sm sm:text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
              We started Singaraa with a clear intention: to reconnect modern snacking with familiar Indian memories. We believe that premium doesn't have to mean unfamiliar, and the most comforting tastes often come from the simplest roots.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
